import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "d-inline-block py-3 px-4 badge bg-danger fs-4 unregisterd-warning"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)



  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterButton',
  props: {
    registerButtonSimple: { type: Boolean, default:false },
    login: { type: Boolean },
    eventHolding: { type: Boolean },
    cart: { type: Object },
  },
  emits: ['submitForm'],
  setup(__props, { emit: __emit }) {

  const props = __props
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const emits = __emit;

  const submitForm = () => {
    emits('submitForm');
  }


return (_ctx: any,_cache: any) => {
  return (__props.eventHolding)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["text-center session-timetable-submit-btn", !__props.registerButtonSimple ? ' mt-n5 py-7' : ''])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["mx-auto", !__props.registerButtonSimple ? ' charcter-large' : ''])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-accent2", (!__props.registerButtonSimple ? ' px-2 px-lg-5 btn-lg fw-bold fs-lg-2' : ' fw-normal') + (!__props.login ? ' button-register' : ' button-register-more')]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (submitForm()))
          }, [
            (!__props.login)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "参加申込する（無料）"))
              : _createCommentVNode("", true),
            (__props.login)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "追加申込する（無料）"))
              : _createCommentVNode("", true)
          ], 2),
          (__props.cart && __props.cart.length != 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createTextVNode("申込が完了していない"),
                _hoisted_4,
                _createTextVNode("セッションがあります！")
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})